import { ActionTypes } from "./types";
import { addLabelArray } from "helpers/addLabelArray";
import { orderArrayV2 } from "helpers/orderArray";
import { liquidationStatus } from "helpers/dictionary";
import { newDate } from "helpers/dateTools";

const {
  CLEAR_LIQUIDATIONS,
  GET_LIQUIDATIONS,
  SET_LIQUIDATIONS_FILTERS,
  GET_PAYMENTS,
  GET_CUSTOMERS_LIQUIDATIONS,
  CLEAR_CUSTOMERS_LIQUIDATIONS,
  CREATE_LIQUIDATION_STATION_SALE,
  ADD_SGC_LIQUIDATION_SALE,
  EDIT_LIQUIDATION_STATION_SALE,
  REMOVE_LIQUIDATION,
  SET_CONFIG_PAGE_LIQUIDATION,
  SET_CONFIG_PAGE_SIZE_LIQUIDATION,
  SET_CONFIG_FILTER_LIQUIDATION,
  SET_CONFIG_SORTED_LIQUIDATION,
  SET_UNIT_INFORMATION,
  SET_SELL_STATION_LIQUIDATION,
  SET_SGC_TO_LIQUIDATION,
  UPDATE_LIQUIDATION_DATE,
  REGENERATE_PDF,
  RESTORE_INITIAL,
  REGENERATE_TRANSFER_INVOICE_PDF,
  RENEW_FILLING_ORDERS,
  REPLACE_SETTLEMENT,
} = ActionTypes;

const INITIAL_STATE = {
  liquidations: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
  accounts: [],
  payments: [],
  liquidation: {},
  config: {
    page: 0,
    pageSize: 20,
    filtered: [],
    sorted: []
  },
};

export const liquidationsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CLEAR_LIQUIDATIONS:
      return {
        ...state,
      };

    case SET_LIQUIDATIONS_FILTERS:
      let liquidations = state.liquidations

      if (payload.key === 'station') liquidations = []
      return {
        ...state,
        [payload.key]: payload.value,
        liquidations
      };

    case GET_LIQUIDATIONS:
      const formatDates = payload.liquidations.map(liquidation => ({
        ...liquidation,
        date: liquidation.date.split('.')[0],
        typeS: liquidation?.settlementType.toLowerCase() === 'p' ? 'Venta Planta' : `Venta ${liquidation.isManual === 1 ? 'Manual' : 'Normal'}`,
        folioS: liquidation.folio.toString(),
        nStatus: liquidationStatus.label[liquidation.status],
      }))

      const order = orderArrayV2(formatDates, 'date', true)

      return {
        ...state,
        liquidations: order,
        station: payload.station,
      };

    case GET_CUSTOMERS_LIQUIDATIONS:
      return {
        ...state,
        accounts: payload,
      }

    case CLEAR_CUSTOMERS_LIQUIDATIONS:
      return {
        ...state,
        accounts: [],
      }

    case GET_PAYMENTS:
      const payments = addLabelArray(payload, 'name')
      return {
        ...state,
        payments: payments,
      };

    case SET_UNIT_INFORMATION:
      return {
        ...state,
        newLiquidation: {
          ...state.newLiquidation,
          unit: payload
        }
      };

    case CREATE_LIQUIDATION_STATION_SALE:
      if (state.station?.id === payload.idStation) {
        const addLiquidation = [payload.response, ...state.liquidations]

        return {
          ...state,
          liquidations: addLiquidation
        };
      }
      return state;

    case ADD_SGC_LIQUIDATION_SALE:
      if (state.station?.id === payload.idStation) {
        let sgcStateL = [...state.liquidations]
        const idx = sgcStateL.findIndex(liq => liq.id === payload.id)
        sgcStateL[idx] = {
          ...sgcStateL[idx],
          fillingOrder: payload.fillingOrder,
          nStatus: "SGC"
        }
        return {
          ...state,
          liquidations: sgcStateL
        }
      }
      return state;

    case EDIT_LIQUIDATION_STATION_SALE:
      let editState = [...state.liquidations]
      const idx = editState.findIndex(liquidation => liquidation.id === payload.id)
      if (idx === -1) return state
      editState[idx] = payload
      return {
        ...state,
        liquidations: editState
      };

    case REMOVE_LIQUIDATION:
      return {
        ...state,
        liquidations: state.liquidations.filter(liquidation => liquidation.id !== payload)
      }

    case SET_CONFIG_FILTER_LIQUIDATION:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };

    case SET_SELL_STATION_LIQUIDATION:
      return {
        ...state,
        liquidation: payload
      }

    case SET_SGC_TO_LIQUIDATION:
      let addSAgcLiq = [...state.liquidations]
      const idxLiq = addSAgcLiq.findIndex(liq => liq.id === payload.liquidationId)
      if (idxLiq === -1) return state
      addSAgcLiq[idxLiq] = {
        ...addSAgcLiq[idxLiq],
        fillingOrder: payload.liquidation
      }
      return {
        ...state,
        liquidations: addSAgcLiq
      };

    case SET_CONFIG_PAGE_LIQUIDATION:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };

    case SET_CONFIG_PAGE_SIZE_LIQUIDATION:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };

    case SET_CONFIG_SORTED_LIQUIDATION:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        }
      };

    case UPDATE_LIQUIDATION_DATE:
      let updateDateLiq = [...state.liquidations]
      const idxDate = updateDateLiq.findIndex(liq => liq.id === payload.id)
      if (idxDate === -1) return state
      updateDateLiq[idxDate] = {
        ...updateDateLiq[idxDate],
        date:  `${newDate({date: payload.date})} 00:00:00`
      }
      return {
        ...state,
        liquidations: updateDateLiq
      };

    case REGENERATE_PDF:
      let updatePdf = [...state.liquidations]
      const idxPdf = updatePdf.findIndex(liq => liq.id === payload.id)
      if (idxPdf === -1) return state
      updatePdf[idxPdf] = {
        ...updatePdf[idxPdf],
        urlTicket: payload.urlTicket
      }
      return {
        ...state,
        liquidations: updatePdf
      };

    case REGENERATE_TRANSFER_INVOICE_PDF:
      const updateTransferInvoice = [...state.liquidations]
      const idxTransferInvoice = updateTransferInvoice.findIndex(liq => liq.id === payload.id)
      if (idxTransferInvoice === -1) return state
      updateTransferInvoice[idxTransferInvoice] = {
        ...updateTransferInvoice[idxTransferInvoice],
        urlTransferInvoice: payload.urlTransferInvoice
      }
      return {
        ...state,
        liquidations: updateTransferInvoice
      };

    case RENEW_FILLING_ORDERS:
      const ordersSummary = payload.orders.map(order => ({
        id: order.id,
        type: order.type,
        status: order.status,
        numberOrder: order.number_order,
        fillingStation: order.filling_station,
        numberOrderExtra: order.number_order_extra,
        operatingStation: order.operating_station,
        externalIdentifier: order.external_identifier,
      }));

      const updatedLiquidations = state.liquidations.map(liq => {
        if (liq.id === payload.liqId) {
          return {
            ...liq,
            fillingOrder: [...(liq.fillingOrder || []), ...ordersSummary],
            renewCounter: (liq.renewCounter || 0) + 1,
          };
        }
        return liq;
      });

      return {
        ...state,
        liquidations: updatedLiquidations,
      };

    case REPLACE_SETTLEMENT:
      return {
        ...state,
        liquidations: state.liquidations.map(liq => {
          if (liq.id === payload.originalId) {
            return { ...liq, status: payload.original.status, nStatus: liquidationStatus.label[payload.original.status] };
          }
          return liq;
        }),
      };

    case RESTORE_INITIAL:
      return INITIAL_STATE;

    default:
      return state;
  }
}